import { PermitFieldType } from '~/client/graph'

export function getWorkflowFieldTypeLabel(fieldType: PermitFieldType): string {
  switch (fieldType) {
    case PermitFieldType.Requester:
      return 'Requester'
    case PermitFieldType.Assignee:
      return 'Responsible'
    case PermitFieldType.Subscriber:
      return 'Subscriber'
    case PermitFieldType.User:
      return 'User'
    case PermitFieldType.PhoneNumber:
      return 'Phone Number'
    default:
      return fieldType
  }
}
